"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detailsResponseSchema = void 0;
const zod_1 = require("zod");
const contactDetails_schema_1 = require("../../../common/schemas/contactDetails.schema");
const datetime_schema_1 = require("../../../common/schemas/datetime.schema");
const longField_schema_1 = require("../../../common/schemas/longField.schema");
const subjectField_schema_1 = require("../../../common/schemas/subjectField.schema");
const shortField_schema_1 = require("../../../common/schemas/shortField.schema");
const selectedItemWithName_schema_1 = require("../../../common/schemas/selectedItemWithName.schema");
const ChangeItemStatus_1 = require("../../types/ChangeItemStatus");
const ChangeItemType_1 = require("../../types/ChangeItemType");
const workflowAction_schema_1 = require("../workflowAction.schema");
const ReceivedVia_1 = require("../../types/ReceivedVia");
const reviewerDetails_schema_1 = require("../../../common/schemas/reviewerDetails.schema");
const amountWithCurrency_schema_1 = require("../common/amountWithCurrency.schema");
exports.detailsResponseSchema = zod_1.z
    .object({
    changeItemType: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ChangeItemType_1.ChangeItemType),
    description: longField_schema_1.longFieldSchema.optional(),
    disciplines: selectedItemWithName_schema_1.selectedItemWithNameSchema.array(),
    dueDate: datetime_schema_1.datetimeSchema.optional(),
    reopenedDate: datetime_schema_1.datetimeSchema.optional(),
    fileCount: zod_1.z.number(),
    from: contactDetails_schema_1.contactDetailsSchema,
    hasCreatedWorkflowAction: zod_1.z.boolean(),
    hasInProgressWorkflowActions: zod_1.z.boolean(),
    id: zod_1.z.string(),
    isOverdue: zod_1.z.boolean(),
    keywords: selectedItemWithName_schema_1.selectedItemWithNameSchema.array(),
    mostRecentWorkflowAction: workflowAction_schema_1.workflowActionSchema,
    number: shortField_schema_1.shortFieldSchema,
    pendingReviewers: contactDetails_schema_1.contactDetailsSchema.array(),
    reviewers: reviewerDetails_schema_1.reviewerDetailsSchema.array(),
    reasons: selectedItemWithName_schema_1.selectedItemWithNameSchema.array(),
    receivedDate: datetime_schema_1.datetimeSchema.optional(),
    receivedVia: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ReceivedVia_1.ReceivedVia).optional(),
    senderNumber: shortField_schema_1.shortFieldSchema.optional(),
    status: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ChangeItemStatus_1.ChangeItemStatus),
    subject: subjectField_schema_1.subjectFieldSchema,
    suggestedRecipientsForReviewResponse: contactDetails_schema_1.contactDetailsSchema.array(),
    version: zod_1.z.string(),
    workflowActionCount: zod_1.z.number(),
    suggestedRecipientsForSubmitProposal: contactDetails_schema_1.contactDetailsSchema.array(),
    hasProposalSubmitted: zod_1.z.boolean(),
    userSubmittedProposal: contactDetails_schema_1.contactDetailsSchema.optional(),
    suggestedRecipientForSubmitSignature: contactDetails_schema_1.contactDetailsSchema.optional(),
    suggestedRecipientsForSendSignedProposal: contactDetails_schema_1.contactDetailsSchema.array(),
    proposedTotalAmount: amountWithCurrency_schema_1.amountWithCurrencySchema.optional(),
    proposedTotalDays: zod_1.z.number().nonnegative().int().optional(),
})
    .strict();
//# sourceMappingURL=detailsResponse.schema.js.map